import './styles.styl'
import 'react-toggle/style.css'

import React from 'react'
import Toggle from 'react-toggle'
import TextfieldModal from '../../textfield-modal'

import {
  EMAILS
} from '../../../settings'

export default class SettingsEmail extends React.Component {
  constructor (props) {
    super(props)

    let state = {
      emails: [],
      showVAT: true,
      showShipping: true,
      formal: false,
      sendTNT: true,
      language: 'nl',
      fromLabel: 'Helpdesk iLoyalty',
      fromName: 'iLoyalty Store',
      fromEmail: 'noreply@iloyaltyserver.com',
      emailTexts: {},
      emailTextPopupVisible: false,
      emailTextPopupText: '',
      emailTextPopupKey: '',
      emailDefaultText: ''
    }

    if (props.data !== null) {
      state = {
        ...state,
        ...props.data
      }
    }

    this.state = state
  }

  setEmailText (key, text) {
    const texts = { ...this.state.emailTexts }
    texts[key] = text
    this.setState({
      emailTexts: texts,
      emailTextPopupVisible: false,
      emailTextPopupText: '',
      emailTextPopupKey: ''
    })
    console.log('TEXTS', texts)
  }

  activateEmailPopup (key) {
    this.setState({
      emailTextPopupVisible: true,
      emailTextPopupText: this.state.emailTexts[key] || this.state.emailDefaultText,
      emailTextPopupKey: key
    })
  }

  deactivateEmailPopup () {
    this.setState({
      emailTextPopupVisible: false,
      emailTextPopupText: '',
      emailTextPopupKey: ''
    })
  }

  slugify (text) {
    return String(text)
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w-]+/g, '') // Remove all non-word chars
      .replace(/--+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }

  saveAndToggle (index) {
    this.props.save({ ...this.state })
    this.props.toggleSection(index)
  }

  saveAndNext (index) {
    this.props.save({ ...this.state })
    this.props.nextSection(index)
  }

  render () {
    const index = this.props.index
    const moduleToggles = EMAILS.map((module, i) => {
      return <div key={i} className='toggle-switch'>
        <Toggle
          checked={this.state.emails.includes(module.id)}
          onChange={e => {
            const state = { ...this.state }

            if (e.target.checked === false && state.emails.indexOf(module.id) !== -1) {
              state.emails.splice(state.emails.indexOf(module.id), 1)
            }

            if (e.target.checked === true && state.emails.indexOf(module.id) === -1) {
              state.emails.push(module.id)
            }

            this.setState({ emails: state.emails })
          }}
        />
        <span>{module.name}. {this.state.emails.indexOf(module.id) !== -1 ? <a className='email-popup-link' onClick={() => { this.activateEmailPopup(module.id) }}>Wijzig tekst...</a> : null}</span>
      </div>
    })

    let content = (
      <div className='row section-content'>
        <div className='col-12'>
          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>BTW</label>
            </div>

            <div className='col-12 col-sm-8'>
              <div className='toggle-switch'>
                <Toggle
                  checked={this.state.showVAT}
                  onChange={e => this.setState({ showVAT: e.target.checked })}
                />
                <span>BTW weergeven</span>
              </div>
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Verzendkosten</label>
            </div>

            <div className='col-12 col-sm-8'>
              <div className='toggle-switch'>
                <Toggle
                  checked={this.state.showShipping}
                  onChange={e => this.setState({ showShipping: e.target.checked })}
                />
                <span>Verzendkosten weergeven</span>
              </div>
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Track & Trace</label>
            </div>

            <div className='col-12 col-sm-8'>
              <div className='toggle-switch'>
                <Toggle
                  checked={this.state.sendTNT}
                  onChange={e => this.setState({ sendTNT: e.target.checked })}
                />
                <span>Track & Trace e-mails versturen (wanneer van toepassing)</span>
              </div>
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Emails</label>
            </div>

            <div className='col-12 col-sm-8'>
              {moduleToggles}
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Template</label>
            </div>

            <div className='col-12 col-sm-8'>
              <div className='toggle-switch'>
                <Toggle
                  checked={this.state.formal}
                  onChange={e => this.setState({ formal: e.target.checked })}
                />
                <span>Formeel (u/uw)</span>
              </div>

              <div className='toggle-switch'>
                <Toggle
                  checked={!this.state.formal}
                  onChange={e => this.setState({ formal: !e.target.checked })}
                />
                <span>Informeel (je/jij)</span>
              </div>

              <div className='form-group'>
                <br />
                <label>Taal</label>
                <select className='form-control' onChange={e => this.setState({ language: e.target.value })} value={this.state.language}>
                  <option value='nl'>Nederlands</option>
                  <option value='en'>Engels</option>
                  <option value='de'>Duits</option>
                  <option value='fr'>Frans</option>
                  <option value='dk'>Deens</option>
                </select>
              </div>
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Afsluiting</label>
            </div>

            <div className='col-12 col-sm-8'>
              <input
                type='text'
                value={this.state.fromLabel}
                onChange={e => this.setState({ fromLabel: e.target.value })}
                className='form-control form-control-sm'
                placeholder='Team iLoyalty'
              />
            </div>
          </div>

          <div className='row subsection'>
            <div className='col-12 col-sm-4'>
              <label className='form-label'>Verzender</label>
            </div>

            <div className='col-12 col-sm-8'>
              <input
                type='text'
                value={this.state.fromName}
                onChange={e => this.setState({ fromName: e.target.value })}
                className='form-control form-control-sm'
                placeholder='iLoyalty Store'
              />
            </div>
          </div>
        </div>
      </div>
    )

    return (
      <section key={index} className={['section', (this.props.open ? 'section-open' : 'section-closed')].join(' ')}>
        <div className='row section-title'>
          <div className='col-10'>
            <h3>E-mails</h3>
          </div>

          <div className='col-2 text-align-right'>
            <a href='#' onClick={() => this.saveAndToggle(index)} className='edit-link'>{this.props.open ? 'Sluiten' : 'Bewerken'}</a>
          </div>
        </div>

        <div className='row section-content'>
          <div className='col-12'>
            {content}
          </div>
        </div>

        <div className='row section-buttons'>
          <div className='col-12 text-align-right'>
            <button className='btn btn-sm btn-secondary btn-rounded' onClick={() => this.saveAndNext(index)}>Volgende &raquo;</button>
          </div>
        </div>

        {this.state.emailTextPopupVisible === true ? <TextfieldModal value={this.state.emailTextPopupText} id={this.state.emailTextPopupKey} onSave={(key, value) => this.setEmailText(key, value)} onCancel={() => this.deactivateEmailPopup()} /> : null}
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/projects/create/settings-email.js